const create = (items, value) =>
  items.reduce(
    (acc, item) => ({
      ...acc,
      [item]: value,
    }),
    {}
  );

const createBatch = ({ elementIds, attributes, value }) =>
  create(elementIds, create(attributes, value));

export default createBatch;
